// extracted by mini-css-extract-plugin
module.exports = {"container":"_2y64u","grid":"_3-L0h","list":"_1390E","title":"_2ggGD"};